export default __webpack_public_path__ + "static/media/8.fc4ba748.jpg";